<template>
  <v-dialog
    v-model="viewDialog"
    scrollable
    persistent
    max-width="1000px"
    @keydown.esc="viewDialog = false"
  >
    <v-card v-if="viewDialog">
      <v-card-title class="label">
        <v-icon
          class="mr-2"
          medium
          color="black"
        >
          mdi-calendar-clock
        </v-icon>
        ENTITY EVENT TASK DETAILS
      </v-card-title>
      <v-divider class="mb-2" />
      <v-card-text class="text-body-1 text--primary">
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Entity type
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.entityType.name }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Source
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.source }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Status
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            <base-tool-tip
              :label="getStatus(entityEventTaskDetail.status).title"
              :icon="getStatus(entityEventTaskDetail.status).image"
              :icon-color="getStatus(entityEventTaskDetail.status).color"
            />
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Entity event id
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.entityEventId }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Entity instance id
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.entityInstanceId }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Target processor id
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.targetProcessorId }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Event time
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            <v-icon>mdi-clock</v-icon> {{ entityEventTaskDetail.eventTime | formatDateTimeFromInstant }}
          </v-col>
        </v-row>
        <v-row
          v-if="entityEventTaskDetail.processingStartTime"
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Processing start time
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            <v-icon>mdi-clock</v-icon> {{ entityEventTaskDetail.processingStartTime | formatDateTimeFromInstant }}
          </v-col>
        </v-row>
        <v-row
          v-if="entityEventTaskDetail.completionTime "
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Completion time
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            <v-icon>mdi-clock</v-icon> {{ entityEventTaskDetail.completionTime | formatDateTimeFromInstant }}
          </v-col>
        </v-row>
        <v-row
          v-if="entityEventTaskDetail.lastFailedTime"
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Last failed time
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            <v-icon>mdi-clock</v-icon> {{ entityEventTaskDetail.lastFailedTime | formatDateTimeFromInstant }}
          </v-col>
        </v-row>
        <v-row
          class="mt-1 mr-0"
          dense
        >
          <v-col
            cols="3"
            class="ml-1 pt-2 pb-2"
          >
            Fail count
          </v-col>
          <v-col class="pt-2 pb-2 pr-0 text--black">
            {{ entityEventTaskDetail.failCount }}
          </v-col>
        </v-row>
        <v-divider class="mt-2" />

        <base-table-paged-with-search
          class="mt-2"
          :table-headers="tableHeaders"
          :items="entityEventTaskDetail.executions"
          :hide-search="true"
          table-heading="ENTITY EVENT TASK EXECUTIONS"
        >
          <template #item.startTime="{ item }">
            {{ item.startTime | formatDateTimeFromInstant }}
          </template>
          <template #item.endTime="{ item }">
            {{ item.endTime | formatDateTimeFromInstant }}
          </template>

          <template #item.status="{ item }">
            <base-tool-tip
              :label="getStatus(item.status).title"
              :icon="getStatus(item.status).image"
              :icon-color="getStatus(item.status).color"
            />
          </template>
        </base-table-paged-with-search>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <base-input-primary-button
          label="Close"
          icon="mdi-close"
          @click="close"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'
import BaseTablePagedWithSearch from '@/base/table/BaseTablePagedWithSearch.vue'
import { entityEventStatusMixin } from '@/mixins/entityEventStatusMixin'
import BaseToolTip from '@/base/tooltip/BaseToolTip.vue'

export default {
  name: 'ViewEntityEventTaskDetailsDialog',
  components: {
    BaseToolTip,
    BaseTablePagedWithSearch,
    BaseInputPrimaryButton
  },
  mixins: [entityEventStatusMixin],
  props: {
    viewDialog: {
      type: Boolean,
      required: true
    },
    entityEventTaskDetail: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    tableHeaders: [
      { text: 'Status', align: 'start', sortable: false, value: 'status', width: '4%' },
      { text: 'Start time', align: 'start', sortable: false, value: 'startTime', width: '20%' },
      { text: 'End time', align: 'start', sortable: false, value: 'endTime', width: '20%' },
      { text: 'Message', align: 'start', sortable: false, value: 'message', width: '66%' }
    ]
  }),
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
